export default [{
  path: '/tipo-atividade',
  component: {
    name: 'tipoAtividadeBase',
    template: '<router-view />',
    meta: {
      resource: 'atividade',
      action: 'read',
      requiredAuth: true,
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'atividades',
    component: () => import('@/app-modulo/comercial/tipo-atividade/TipoAtividadeView.vue'),
    meta: {
      resource: 'atividade',
      action: 'read',
      requiredAuth: true,
      navActiveLink: 'atividades',
      pageTitle: 'Tipos de atividade',
      breadcrumb: [
        {
          text: 'Tipos de atividade',
          to: { name: 'atividades' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'novo',
    name: 'novo-tipo-atividade',
    component: () => import('@/app-modulo/comercial/tipo-atividade/shared/components/TipoAtividade.vue'),
    meta: {
      resource: 'atividade',
      action: 'create',
      requiredAuth: true,
      navActiveLink: 'atividades',
      pageTitle: 'Cadastro de atividade',
      breadcrumb: [
        {
          text: 'Tipos de atividade',
          to: { name: 'atividades' },
        },
        {
          text: 'Novo',
          to: { name: 'novo-tipo-atividade' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'editar/:id',
    name: 'editar-tipo-atividade',
    component: () => import('@/app-modulo/comercial/tipo-atividade/shared/components/TipoAtividade.vue'),
    meta: {
      resource: 'atividade',
      action: 'update',
      requiredAuth: true,
      navActiveLink: 'atividades',
      pageTitle: 'Cadastro de atividade',
      breadcrumb: [
        {
          text: 'Tipos de atividade',
          to: { name: 'atividades' },
        },
        {
          text: 'Editar',
          to: { name: 'editar-tipo-atividade' },
          active: true,
        },
      ],
    },
  }],
},
]
